import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import RestrictedRoute from "./RestrictedRoute";
import { filterByEnvironment } from "../utils/env";

import {
  auth as authRoutes,
  landing as landingRoutes,
  dashboard as dashboardRoutes,
  templates as templateRoutes,
  account as accountRoutes,
  administration as administrationRoutes,
  hidden as hiddenRoutes,
  password as passwordRoutes,
  campaign as campaignRoutes,
  onDemand as onDemandRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import LandingLayout from "../layouts/Landing";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";

import ScrollToTop from "../components/ScrollToTop";

const childRoutes = (Layout, routes) =>
  routes
    .filter(filterByEnvironment)
    .map(
      (
        {
          specialUserRestrictions,
          isPrivate,
          restrictedToLevel,
          children,
          path,
          component: Component,
        },
        index
      ) => {
        let RouteType = Route;
        let parentRestrictedToLevel = restrictedToLevel;
        if (isPrivate) {
          RouteType = PrivateRoute;
        }
        if (restrictedToLevel) {
          RouteType = RestrictedRoute;
        }

        if (specialUserRestrictions) {
          RouteType = RestrictedRoute;
        }

        return children ? (
          // Route item with children
          children
            .filter(filterByEnvironment)
            .map(
              (
                {
                  isPrivate,
                  specialUserRestrictions,
                  restrictedToLevel,
                  path,
                  component: Component,
                },
                index
              ) => {
                let ChildRouteType = RouteType; // If child has more restrictive setting than parent
                if (isPrivate) {
                  ChildRouteType = PrivateRoute;
                }
                if (restrictedToLevel) {
                  ChildRouteType = RestrictedRoute;
                }

                if (specialUserRestrictions) {
                  ChildRouteType = RestrictedRoute;
                }
                return (
                  <ChildRouteType
                    exact
                    key={index}
                    path={path}
                    restrictedToLevel={restrictedToLevel || parentRestrictedToLevel}
                    specialUserRestrictions={specialUserRestrictions}
                    render={(props) => (
                      <Layout>
                        <Component {...props} />
                      </Layout>
                    )}
                  />
                );
              }
            )
        ) : (
          // Route item without children
          <RouteType
            exact
            key={index}
            path={path}
            restrictedToLevel={restrictedToLevel}
            specialUserRestrictions={specialUserRestrictions}
            render={(props) => (
              <Layout>
                <Component {...props} />
              </Layout>
            )}
          />
        );
      }
    );

const Routes = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Redirect exact path="/" to="/auth/sign-in" />

        {childRoutes(LandingLayout, landingRoutes)}

        {childRoutes(DashboardLayout, dashboardRoutes)}

        {childRoutes(DashboardLayout, templateRoutes)}
        {childRoutes(DashboardLayout, accountRoutes)}
        {childRoutes(DashboardLayout, campaignRoutes)}
        {childRoutes(DashboardLayout, onDemandRoutes)}
        {childRoutes(DashboardLayout, administrationRoutes)}
        {childRoutes(DashboardLayout, hiddenRoutes)}
        {childRoutes(DashboardLayout, passwordRoutes)}
        {childRoutes(AuthLayout, authRoutes)}

        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
